
import Vue from 'vue'
import DB from './db'
import Cookie from 'js-cookie'
import * as storage from './storage'
import invokeNative from './invokeNative'
import bus from './bus'

export function getQuery(e) {
  const n = window.location.search.match(new RegExp("(\\?|&)" + e + "=([^&]*)(&|$)"));
  return n ? decodeURIComponent(n[2]) : ""
}

export function getHash(e) {
  const n = window.location.hash.match(new RegExp("(#|&)" + e + "=([^&]*)(&|$)"));
  return n ? decodeURIComponent(n[2]) : ""
}

export function getGameId() {
  const domain = location.hostname
  /* if (domain.match(/ma68alltv\.game\.163\.com$/i)) {
    return 'ma68'
  } else if(domain.match(/ma78alltv\.game\.163\.com$/i)){
    return 'ma78'
  } else */
  const pathname = location.pathname
  if(domain.match(/sv(dev|test)?-zhibo.game.163.com/)){
    return 'ma68'
  } else if(domain.match(/pes(dev|test)?-zhibo.game.163.com/)){
    return 'ma78'
  } else if(domain.match(/pescc(dev|test)?-zhibo.game.163.com/)){
    return 'ma80'
  } else if(domain.match(/dl-live(-test)?.game.163.com/)){//https://dl-live-test.game.163.com/#/
    return 'ma84'
  } else if(pathname.match(/ma78\.html$/)){
    return 'ma78'
  }  else if(pathname.match(/ma80\.html$/)){
    return 'ma80'
  }  else if(pathname.match(/ma84\.html$/)){
    return 'ma84'
  }  else {
    return getQuery('game') || 'ma68'
  }
}

export function isProduction() {
  return true
  const domain = window.location.host
  return domain === 'sv-zhibo.game.163.com' || domain === 'pes-zhibo.game.163.com' || domain === 'pescc-zhibo.game.163.com'
}

export function getPlatform(){
  const ua = navigator.userAgent
  if(ua.match(/ipod|iphone|ipad/i)){
    return 'ios'
  }else if(ua.match(/Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i)){
    return 'android'
  }else{
    return 'pc'
  }
}

export function getAndroidVersion(){
  if(getPlatform() === 'android'){
    const v = navigator.userAgent.match(/Android([^;]+);/i)
    if(v){
      return v[1].trim().split('.');
    }
  }
  return '99.99.99'.split('.');
}

export function useVideoElement(){
  //return true;
  if(getPlatform()!=='android') return false
  const ua = navigator.userAgent
  const versionList = getAndroidVersion()
  //android 4.4 以下版本使用原始video标签
  if(versionList[0] < 4 || (versionList[0] == 4 && versionList[1] < 4)){
    return true
  }

  const strangePhones = [/MI 3/i,/HM NOTE 1/i,/HonorG621/i];
  if(strangePhones.find(x => x.test(ua))){
    //小米3, 红米note 1的原生MediaSource不支持手动修改duration, 只能使用原始video 见 #README.md
    return true
  }

  const matches = ua.match(/chrome\/([^\s]+)/i)
  // console.log(matches)
  return matches ? parseInt(matches[1], 10) <= 10 : false
}

export function isLockScreenDestoryVideo(){
  //对特殊机型...在后台pause不会停止播放,需要销毁video元素
  const strangePhones = [
    /ZUK Z2121/i,// Lenovo ZUK Z2    

    /OPPO\sA73/i,//OPPO A73
    /*
    OPPO A73（GIH-PHO-2747） Android 7.1.1
    Mozilla/5.0 (Linux; U; Android 7.1.1; zh-cn; OPPO A73 Build/N6F26Q) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/70.0.3538.80 Mobile Safari/537.36
    */
    /vivo\sX9Plus/i,//vivo X9 Plus
    /*
    vivo X9 Plus（GIH-PHO-2575） Android 7.1.1
    Mozilla/5.0 (Linux; Android 7.1.1; vivo X9Plus Build/NMF26F; wv) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.84 Mobile Safari/537.36 VivoBrowser/7.5.12.0
    */
    /vivo\sX9s/i,//vivo X9s
    /*
    vivo X9s（GIH-PHO-2429） Android 7.1.1
    Mozilla/5.0 (Linux; Android 7.1.1; vivo X9s Build/NMF26F; wv) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.84 Mobile Safari/537.36 VivoBrowser/7.5.12.0
    */
    /SM\-G9200/i,//三星 Galaxy S6
    /*
    三星 Galaxy S6（SM-G9209）（GIH-PHO-1253） Android 6.0.1
    Mozilla/5.0 (Linux; Android 6.0.1; SAMSUNG-SM-G9209 Build/MMB29K) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/4.0 Chrome/44.0.2403.133 Mobile Safari/537.36 
    */
    /CAM\-AL00/i,//华为 荣耀畅玩 5A
    /*
    华为 荣耀畅玩 5A（CAM-AL00）（GIH-PHO-2370） Android 6.0
    Mozilla/5.0 (Linux; U; Android 6.0;zh-cn; CAM-AL00 Build/HONORCAM-AL00) AppleWebKit/537.36 (KHTML, like Gecko)Version/4.0 Chrome/57.0.2987.132 MQQBrowser/8.1 Mobile Safari/537.36
    */
    /vivo X6Plus A/i, 
    /*
    Mozilla/5.0 (Linux; Android 5.0.2; vivo X6Plus A Build/LRX22G) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/38.0.0.0 Mobile Safari/537.36
    */
  ]; 
  if(strangePhones.find(x => x.test(navigator.userAgent))){
    return true
  }
  return false
}

export const sortTypeMap = {
  zh: '综合',
  ob: '人气',
  rd: '随机'
}

export function getApkChannel(){
  const ua = navigator.userAgent
  const matches = ua.match(/uniweb-channel\/([^\s]+)(\s|$)/)
  return matches ? matches[1] : 'default'
}

const needNativeRequestReg = [/live\.panda\.tv\/live_panda/,]

export function getCORSUrl(options){
  let request = {
    method: 'get',
    url: '',
    data: undefined,
    mimeType: 'application/json'
  };
  if(typeof(options) === 'string'){
    request.url = options;
  }else{
    request = Object.assign(request, options);
  }
  if(getPlatform() === 'android' && needNativeRequestReg.find(x => x.test(request.url))){
    if(!request.url.startsWith('http')){
      request.url = location.protocol + request.url;
    }
    return `${location.protocol}//nativerequest/` + encodeURIComponent(JSON.stringify(request));
  }else{
    return request.url;
  }
}

export function objectToStringObj(obj, level = 1){
  let result = {};
  for(var key in obj){
    var value = '';
    try{
      value = obj[key];
    }catch (e){
      continue;
    }
    let type = typeof(value);
    switch(type){
      case 'function' : break;
      case 'object' :
        if(level > 1 && value !== null){
          result[key] = objectToStringObj(value, level - 1);
        }
        break;
      default :
        result[key] = value;
        break;
    }
  }
  return result;
}

let serverTime = Date.now()
let recordedTime = Date.now()

export function setServerTime(st){
  recordedTime = Date.now()
  serverTime = st
}
export function getServerTime(){
  return serverTime + (Date.now() - recordedTime)
}

Vue.filter('tenThousand', (val) => {
  return val > 10000 ? (val / 10000).toFixed(2).replace(/0+$/, '').replace(/\.$/, '') + '万' : val
})

//自动根据宽度缩放高度
Vue.directive('image-auto-height', {
  inserted: function (el) {
    el.addEventListener('load', ()=>{
      const n_height = el.naturalHeight;
      const n_width = el.naturalWidth;
      const el_width = el.width || el.style.width;
      const el_height = el.height || el.style.height;
      const calc_height = Math.floor(n_height / n_width * el_width);
      if(Math.abs(el_height - calc_height) >= 2){
        console.log(`fix image height ${calc_height}`)
        el.height = calc_height;
      }
    })
  },
})

//修复flex-wrap
Vue.directive('fix-flex-wrap', {
  inserted: function (el) {
    if(getPlatform() !== 'android'){
      return
    }
    const versionList = getAndroidVersion()
    //android 4.4 以下版本使用原始video标签
    if(versionList[0] < 4 || (versionList[0] == 4 && versionList[1] < 4)){
      el.style.display = 'block';
      const el_width = el.clientWidth;
      let child_width = 0;
      let child_num = 0;
      //alert(`clientWidth ${el_width} child ${el.childNodes.length}`)
      for(var i = 0;i < el.childNodes.length; i++){
        let node = el.childNodes[i];
        node.style.float = 'left';
        let this_width = node.clientWidth;
        if(child_num > 1 && child_width + this_width > el_width){
          let br = document.createElement('br');
          el.insertBefore(br, node);
          child_num = 0;
          child_width = 0;
        }
        child_num++;
        child_width += this_width;
      }
    }
  },
})

export function getLocationFromStr(url){
  const $a = document.createElement('a')
  $a.href = url
  return $a
}

export { Vue, DB, Cookie, storage, invokeNative, bus }



// WEBPACK FOOTER //
// ./src/common/index.js